import {
  AutocompleteInputChangeReason,
  Grid,
  Typography,
  debounce,
} from "@mui/material";
import CustomAutocompleteMulti from "../../../../common/components/functional/customAutocomplete/CustomAutocompleteMulti";
import { AutocompleteType } from "../../../../common/types/autoComplete";
import { useTranslation } from "react-i18next";
import { SyntheticEvent, useState } from "react";

interface Options {
  skills: AutocompleteType[];
}

type Props = {
  disableEdit: boolean;
  skills: AutocompleteType[];
  onRequirementsChange: (skills: AutocompleteType[]) => void;
};

const initialSearchTerms = {
  skills: "",
};

export const Skills = ({
  disableEdit,
  skills,
  onRequirementsChange,
}: Props) => {
  const { t } = useTranslation(["order", "skills"]);

  const [defaultValues, setDefaultValues] = useState<Options>({
    skills: skills,
  });
  const [searchTerms, setSearchTerms] = useState(initialSearchTerms);

  const onChange = (
    e: SyntheticEvent<Element, Event>,
    newValue: AutocompleteType[] | null,
    name: string,
  ) => {
    if (newValue) {
      const requirements = {
        skills,
        [name]: newValue,
      };
      onRequirementsChange(requirements.skills);
    }
  };

  const onInputChange = debounce(
    (key: string, term: string, reason?: AutocompleteInputChangeReason) => {
      setSearchTerms({ ...searchTerms, [key]: term });

      if (!term) {
        setDefaultValues({ ...defaultValues, [key]: [] });
      }
    },
    400,
  );

  return (
    <>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("common:skills")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <CustomAutocompleteMulti
          disabled={disableEdit}
          options={defaultValues.skills}
          fullWidth
          onChange={onChange}
          name="skills"
          onInputChange={onInputChange}
          defaultValue={defaultValues.skills}
          onOpen={() => {}}
        />
      </Grid>
    </>
  );
};
